import axios from '../api/axios'

export default {
    signIn({params, callback}){ // 登录
        axios.post(`/v1/admin/login`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },

    logout({callback}){ // 退出登录 清除token
        axios.post(`/v1/admin/logout`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/login.js